import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function FirmValidationForm({ onValidSubmit }) {
    const [email, setEmail] = useState('');
    //const [firmName, setFirmName] = useState('');
    const [currency, setCurrency] = useState('-');
    const [message, setMessage] = useState('');
    const [emailError, setEmailError] = useState(''); 

    const navigate = useNavigate();
    const isValidEmail = (email) => {
        // Basic email regex (you can find more robust versions online)
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      };
    const handleEmailChange = (e) => {
        const newEmail = e.target.value;
        setEmail(newEmail);
        setEmailError('');
        if (newEmail && !isValidEmail(newEmail)) {
            setEmailError('Please enter a valid email address.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        if (!email) {
            setEmailError('Email is required.');
            return;
        }
        if (!isValidEmail(email)) {
            setEmailError('Please enter a valid email address.');
            return;
        }
        try {
            const response = await fetch('https://cloud9requests.symphony.com/requests/api/request_verification', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ firm_id: email }),
            });
            const data = await response.json();
            if (response.ok) {
                // Verification link successfully sent
                setMessage('A verification link has been sent to your email. Please close this tab and launch the form from your email.');
              } else {
                setMessage(data.message || 'Failed to send verification link.');
              }
            } catch (error) {
              console.error('Error:', error);
              setMessage('Something went wrong.');
            }
          };

    return (
        <div className="opportunity-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
           <img src="https://cloud9requests.symphony.com/Cloud9_Logo.png" alt="C9 Logo" width="300" height="100"></img>
           {!message && (
            <form onSubmit={handleSubmit}>
                <label>
                    Email:
                    <input
                        type="text"
                        value={email}
                        onChange={handleEmailChange}
                    />
                </label>
                {emailError && <p style={{ color: 'red' }}>{emailError}</p>} 
                <br/>
                <button   style={{ marginLeft: '45px' }} type="submit" disabled={emailError}>Submit</button>
            </form>
           )}
            {message && <p style={{ marginTop: '20px', textAlign: 'center', maxWidth: '400px' }}>{message}</p>}
        </div>
    );
}

export default FirmValidationForm;
